<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
<ng-template #contentTemplate>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header d-flex justify-content-between py-0">
      <h4 class="offcanvas-title mt-0">
        Repository: {{ repoDetails?.basicInfo?.name || "Loading..." }}
      </h4>
      <div>
        <button
          type="button"
          class="actionBtn"
          placement="top auto"
          container="body"
          triggers="hover"
          (click)="refreshComponent()"
          [disabled]="isLoading"
          ngbTooltip="Refresh Details"
        >
          <span
            class="bi bi-arrow-clockwise"
            [class.spinning]="isLoading"
          ></span>
        </button>
        <button
          type="button"
          class="actionBtn"
          (click)="close()"
          matTooltip="Close"
        >
          <mat-icon
            style="color: red"
            class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color bi bi-x-lg"
          ></mat-icon>
        </button>
      </div>
    </div>
    <div
      style="padding: 20px"
      class="offcanvas-body flex-grow-1 py-0 pt-1 d-flex flex-column"
    >
      <div class="options">
        <p
          class="active"
          [title]="repoDetails?.basicInfo?.description || 'Repository Details'"
        >
          Repository Details
        </p>
      </div>
      <div class="childs flex-grow-1">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          [(selectedIndex)]="currentActiveIndex"
        >
          <mat-tab label="MetaData" class="p-1">
            @if (error) {
            <div class="alert alert-danger">
              {{ error }}
              <button
                class="btn btn-sm btn-outline-primary ms-2"
                (click)="refreshComponent()"
              >
                Retry
              </button>
            </div>
            } @else if (isLoading) {
            <div class="h-100 w-100">
              <ngx-spinner
                bdColor="rgba(0,0,0,0)"
                size="default"
                zIndex="1"
                color="var(--s-primary-color)"
                type="ball-spin"
                [fullScreen]="false"
                name="repoSpinner"
              >
              </ngx-spinner>
            </div>
            } @else if (repoDetails) {
            <!-- Content state -->
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="job-overview">
                    <div class="info-grid-overview">
                      <div class="info-item">
                        <mat-icon
                          class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color bi bi-collection"
                        ></mat-icon>
                        <div class="info-content">
                          <span class="label">Repository Name:</span>
                          <span class="value">{{
                            repoDetails.basicInfo.name
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon
                          class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color bi bi-person"
                        ></mat-icon>
                        <div class="info-content">
                          <span class="label">Owner:</span>
                          <span class="value">{{
                            repoDetails.basicInfo.owner.login
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon
                          class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color bi bi-shield"
                        ></mat-icon>
                        <div class="info-content">
                          <span class="label">Visibility:</span>
                          <span class="value">{{
                            repoDetails.basicInfo.private ? "Private" : "Public"
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </section>

                  <mat-divider></mat-divider>

                  <section class="additional-information">
                    <h2>Repository Information</h2>
                    <div class="info-grid-compact">
                      <div class="info-item-compact">
                        <span class="label">Full Name:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.fullName
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Description:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.description || "No description"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Language:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.language || "Not specified"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Default Branch:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.defaultBranch
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Size:</span>
                        <span class="value"
                          >{{ repoDetails.basicInfo.size }} KB</span
                        >
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Created:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.createdAt | date : "medium"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Updated:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.updatedAt | date : "medium"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Fork:</span>
                        <span class="value">{{
                          repoDetails.basicInfo.fork ? "Yes" : "No"
                        }}</span>
                      </div>
                    </div>
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="noContent"></ng-container>
            }
          </mat-tab>

          <mat-tab label="Branches" class="p-1">
            @if (repoDetails?.branches && repoDetails.branches.length > 0) {
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="enhanced-branches-section">
                    <h2>Branches ({{ repoDetails.branches.length }})</h2>
                    <div class="enhanced-branches-grid">
                      @for (branch of repoDetails.branches; track branch.name) {
                      <div class="enhanced-branch-card">
                        <div class="enhanced-branch-header">
                          <div class="enhanced-branch-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 16 16"
                              width="20"
                              height="20"
                              aria-hidden="true"
                              class="enhanced-branch-svg"
                            >
                              <path
                                d="M9.5 3.25a2.25 2.25 0 1 1 3 2.122V6A2.5 2.5 0 0 1 10 8.5H6a1 1 0 0 0-1 1v1.128a2.251 2.251 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.5 0v1.836A2.5 2.5 0 0 1 6 7h4a1 1 0 0 0 1-1v-.628A2.25 2.25 0 0 1 9.5 3.25m-6 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m8.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
                              ></path>
                            </svg>
                          </div>
                          <div class="enhanced-branch-info">
                            <div class="enhanced-branch-name-container">
                              <h4 class="enhanced-branch-name">
                                {{ branch.name }}
                                @if (branch.name ===
                                repoDetails.basicInfo.defaultBranch) {
                                <span
                                  class="enhanced-badge enhanced-badge-default"
                                >
                                  <i class="bi bi-star-fill me-1"></i>
                                  Default
                                </span>
                                }
                              </h4>
                            </div>
                            @if (branch.protected) {
                            <div class="enhanced-branch-badges">
                              <span
                                class="enhanced-badge enhanced-badge-protected"
                              >
                                <i class="bi bi-shield-lock-fill me-1"></i>
                                Protected
                              </span>
                            </div>
                            }
                          </div>
                        </div>
                        <div class="enhanced-branch-details">
                          <div class="enhanced-branch-commit">
                            <i class="bi bi-git me-1"></i>
                            <span class="enhanced-commit-sha">{{
                              branch.commit.sha?.substring(0, 8)
                            }}</span>
                          </div>
                          @if (branch.commit.message) {
                          <div class="enhanced-branch-commit-message">
                            <i class="bi bi-chat-left-text me-1"></i>
                            <span class="enhanced-commit-message">{{
                              branch.commit.message
                            }}</span>
                          </div>
                          } @if (branch.commit.author) {
                          <div class="enhanced-branch-author">
                            <i class="bi bi-person me-1"></i>
                            <span>{{ branch.commit.author.name }}</span>
                            <span class="enhanced-commit-date ms-2">
                              <i class="bi bi-calendar3 me-1"></i>
                              {{ branch.commit.author.date | date : "short" }}
                            </span>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <div class="text-center py-4">
              <div class="enhanced-empty-state">
                <i class="bi bi-git" style="font-size: 3rem; color: #ccc"></i>
                <p class="mt-3">No branches found</p>
              </div>
            </div>
            }
          </mat-tab>

          <mat-tab label="Commits" class="p-1">
            @if (repoDetails?.commits && repoDetails.commits.length > 0) {
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="commits-section">
                    <h2>Recent Commits ({{ repoDetails.commits.length }})</h2>
                    <div class="commits-list">
                      @for (commit of repoDetails.commits; track commit.sha) {
                      <div class="commit-item">
                        <div class="commit-header">
                          <div class="commit-info">
                            <div class="pr-status">
                              <svg
                                viewBox="0 0 16 16"
                                class="svg octicon-git-commit"
                                aria-hidden="true"
                                width="16"
                                height="16"
                              >
                                <path
                                  fill="red"
                                  d="M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
                                ></path>
                              </svg>
                            </div>

                            <div class="commit-details">
                              <h4 class="commit-message">
                                {{ commit.commit.message }}
                              </h4>
                              <div class="commit-meta">
                                <span class="commit-author">
                                  <i class="bi bi-person"></i>
                                  {{ commit.commit.author.name }}
                                </span>
                                <span class="commit-date">
                                  <i class="bi bi-calendar-event"></i>
                                  {{
                                    commit.commit.author.date | date : "medium"
                                  }}
                                </span>
                                <span class="commit-sha">
                                  {{ commit.sha.substring(0, 8) }}
                                </span>
                              </div>
                            </div>
                          </div>
                          @if (commit.html_url) {
                          <button
                            class="btn btn-sm btn-outline-primary"
                            (click)="openCommitUrl(commit.html_url)"
                          >
                            <i class="bi bi-link"></i>
                            View
                          </button>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <div class="text-center py-4">
              <p>No commits found</p>
            </div>
            }
          </mat-tab>

          <mat-tab label="Contributors" class="p-1">
            <ng-container
              *ngIf="
                repoDetails?.contributors &&
                  repoDetails.contributors.length > 0;
                else noContributors
              "
            >
              <div class="job-details-container">
                <mat-card class="mat-elevation-z2 main-card">
                  <mat-card-content class="pt-1 px-2">
                    <section class="contributors-section">
                      <h2>
                        Contributors ({{ repoDetails.contributors.length }})
                      </h2>
                      <div class="contributors-grid">
                        <ng-container
                          *ngFor="
                            let contributor of repoDetails.contributors;
                            trackBy: trackContributorId
                          "
                        >
                          <div class="contributor-card">
                            <div class="contributor-avatar">
                              <ng-container
                                *ngIf="
                                  contributor.avatar_url;
                                  else defaultAvatar
                                "
                              >
                                <img
                                  [src]="contributor.avatar_url"
                                  [alt]="contributor.login"
                                  class="avatar-img"
                                />
                              </ng-container>
                              <ng-template #defaultAvatar>
                                <div class="default-avatar">
                                  <mat-icon>person</mat-icon>
                                </div>
                              </ng-template>
                            </div>
                            <div class="contributor-info">
                              <h4 class="contributor-name">
                                {{ contributor.fullName || contributor.login }}
                              </h4>
                              <p class="contributor-login">
                                {{ contributor.login }}
                              </p>
                              <ng-container *ngIf="contributor.email">
                                <p class="contributor-email">
                                  {{ contributor.email }}
                                </p>
                              </ng-container>
                              <div class="contribution-count">
                                {{ contributor.contributions }} contributions
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </section>
                  </mat-card-content>
                </mat-card>
              </div>
            </ng-container>
            <ng-template #noContributors>
              <div class="text-center py-4">
                <p>No contributors found</p>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Pull Requests" class="p-1">
            @if (repoDetails?.pullRequests && repoDetails.pullRequests.length >
            0) {
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="pull-requests-section">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <h2>
                        Pull Requests ({{ filteredPullRequests.length }} of
                        {{ repoDetails.pullRequests.length }})
                      </h2>
                      <div class="filter-container">
                        <label for="prFilter" class="form-label me-2"
                          >Filter by state:</label
                        >
                        <select
                          id="prFilter"
                          class="form-select form-select-sm"
                          [(ngModel)]="prStateFilter"
                          (change)="onPrFilterChange(prStateFilter)"
                        >
                          <option value="all">All</option>
                          <option value="open">Open</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                    </div>

                    @if (filteredPullRequests.length > 0) {
                    <div class="pull-requests-list">
                      @for (pr of filteredPullRequests; track pr.id) {
                      <div class="pull-request-item">
                        <div class="pr-header">
                          <div class="pr-info">
                            @if(pr.state == "open"){
                            <div class="pr-status">
                              <svg
                                viewBox="0 0 16 16"
                                aria-hidden="true"
                                width="16"
                                height="16"
                              >
                                <path
                                  fill="#87ab63"
                                  d="M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25m5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354M3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
                                ></path>
                              </svg>
                            </div>
                            } @else if(pr.state == "closed"){
                            <div class="pr-status">
                              <svg
                                viewBox="0 0 16 16"
                                aria-hidden="true"
                                width="16"
                                height="16"
                              >
                                <path
                                  fill="#b259d0"
                                  d="M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.73 5.73 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218M4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M5 3.25a.75.75 0 1 0 0 .005z"
                                ></path>
                              </svg>
                            </div>
                            }

                            <div class="pr-details">
                              <div class="d-flex align-items-center gap-2 mb-2">
                                @if(pr.state == "open"){
                                <span class="badge bg-success">Open</span>
                                }@else {
                                <span class="badge bg-secondary">Closed</span>
                                }
                                <h4 class="pr-title mb-0">
                                  {{ pr.title }}
                                </h4>
                              </div>

                              <div class="pr-meta">
                                <span class="pr-author">
                                  <i class="bi bi-person"></i>
                                  {{ pr.user.login }}
                                </span>
                                <span class="pr-date">
                                  <i class="bi bi-calendar-event"></i>
                                  {{ pr.created_at | date : "medium" }}
                                </span>
                                <span class="pr-branch">
                                  {{ pr.head.ref }} → {{ pr.base.ref }}
                                </span>
                              </div>
                              @if (pr.body) {
                              <p class="pr-description">{{ pr.body }}</p>
                              }
                            </div>
                          </div>
                          @if (pr.html_url) {
                          <button
                            class="btn btn-sm btn-outline-primary"
                            (click)="openPrUrl(pr.html_url)"
                          >
                            <i class="bi bi-link"></i>
                            View
                          </button>
                          }
                        </div>
                      </div>
                      }
                    </div>
                    } @else {
                    <div class="text-center py-4">
                      <p>No pull requests found for the selected filter.</p>
                    </div>
                    }
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <div class="text-center py-4">
              <p>No pull requests found</p>
            </div>
            }
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noContent>
  <div class="d-flex flex-column h-100 w-100">
    <p class="pt-5 text-center">No repository data available!</p>
  </div>
</ng-template>
